import { data1 as defaultData1, data2 as defaultData2, data as defaultData } from './data';
import _ from 'lodash';
import { calculation, numConvert, sum } from '@/method'

export default ({ data1_1, data5_0, data5_1_1, data5_1_3, last1, last5_0, last5_1_1, last5_1_3, list2_1, list2_2, max }) => {
    let data1 = _.cloneDeep(defaultData1);
    let data2 = _.cloneDeep(defaultData2);
    let data3 = _.cloneDeep(defaultData2);
    let data4 = _.cloneDeep(defaultData2);
    let data5 = _.cloneDeep(defaultData2);
    let data6 = _.cloneDeep(defaultData2);
    let data7 = _.cloneDeep(defaultData2);
    let data = _.cloneDeep(defaultData);

    for (let index = 0; index < 2; index++) {
        data1[index].fb = _.get(data5_0, '0.ytdActual', 0);
        data1[index].fb_prop = _.get(data5_0, '13.ytdActual', 0);
        data1[index].ac = _.get(data5_1_3, '13.m_AC', 0);
        data1[index].covers = _.get(data5_1_3, '13.m_covers', 0);
        data1[index].fb_profit = _.get(data5_0, '2.ytdActual', 0);
        data1[index].fb_payroll = calculation(_.get(data5_0, '12.ytdActual', 0), _.get(data5_0, '0.ytdActual', 0), 4)
        data1[index].fb_sales = _.get(data1_1, '14.year_actual', 0);

        data1[index + 2].fb = _.get(data5_0, '0.actual', 0);
        data1[index + 2].fb_prop = _.get(data5_0, '13.actual', 0);
        data1[index + 2].ac = _.get(data5_1_1, '13.m_AC', 0);
        data1[index + 2].covers = _.get(data5_1_1, '13.m_covers', 0);
        data1[index + 2].fb_profit = _.get(data5_0, '2.actual', 0);
        data1[index + 2].fb_payroll = calculation(_.get(data5_0, '12.actual', 0), _.get(data5_0, '0.actual', 0), 4)
        data1[index + 2].fb_sales = _.get(data1_1, '14.actual', 0);
    }

    data1[0].fb_last = _.get(last5_0, '0.ytdActual', 0);
    data1[0].fb_prop_last = _.get(last5_0, '13.ytdActual', 0);
    data1[0].ac_last = _.get(last5_1_3, '13.m_AC', 0);
    data1[0].covers_last = _.get(last5_1_3, '13.m_covers', 0);
    data1[0].fb_profit_last = _.get(last5_0, '2.ytdActual', 0);
    data1[0].fb_payroll_last = calculation(_.get(last5_0, '12.ytdActual', 0), _.get(last5_0, '0.ytdActual', 0), 4)
    data1[0].fb_sales_last = _.get(last1, '14.year_actual', 0);

    data1[1].fb_last = _.get(data5_0, '0.ytdBudget', 0);
    data1[1].fb_prop_last = _.get(data5_0, '13.ytdBudget', 0);
    data1[1].ac_last = _.get(data5_1_3, '13.b_AC', 0);
    data1[1].covers_last = _.get(data5_1_3, '13.b_covers', 0);
    data1[1].fb_profit_last = _.get(data5_0, '2.ytdBudget', 0);
    data1[1].fb_payroll_last = calculation(_.get(data5_0, '12.ytdBudget', 0), _.get(data5_0, '0.ytdBudget', 0), 4)
    data1[1].fb_sales_last = _.get(data1_1, '14.year_budget', 0);

    data1[2].fb_last = _.get(last5_0, '0.actual', 0);
    data1[2].fb_prop_last = _.get(last5_0, '13.actual', 0);
    data1[2].ac_last = _.get(last5_1_1, '13.m_AC', 0);
    data1[2].covers_last = _.get(last5_1_1, '13.m_covers', 0);
    data1[2].fb_profit_last = _.get(last5_0, '2.actual', 0);
    data1[2].fb_payroll_last = calculation(_.get(last5_0, '12.actual', 0), _.get(last5_0, '0.actual', 0), 4)
    data1[2].fb_sales_last = _.get(last1, '14.actual', 0);

    data1[3].fb_last = _.get(data5_0, '0.budget', 0);
    data1[3].fb_prop_last = _.get(data5_0, '13.budget', 0);
    data1[3].ac_last = _.get(data5_1_1, '13.b_AC', 0);
    data1[3].covers_last = _.get(data5_1_1, '13.b_covers', 0);
    data1[3].fb_profit_last = _.get(data5_0, '2.budget', 0);
    data1[3].fb_payroll_last = calculation(_.get(data5_0, '12.budget', 0), _.get(data5_0, '0.budget', 0), 4)
    data1[3].fb_sales_last = _.get(data1_1, '14.budget', 0);


    for (let i = 0; i < data1.length; i++) {
        data1[i].fb_vs = numConvert(data1[i].fb - data1[i].fb_last, 4);
        data1[i].fb_prop_vs = numConvert(data1[i].fb_prop - data1[i].fb_prop_last, 4);
        data1[i].ac_vs = numConvert(data1[i].ac - data1[i].ac_last, 4);
        data1[i].covers_vs = numConvert(data1[i].covers - data1[i].covers_last, 4);
        data1[i].fb_profit_vs = numConvert(data1[i].fb_profit - data1[i].fb_profit_last, 4);
        data1[i].fb_payroll_vs = numConvert(data1[i].fb_payroll - data1[i].fb_payroll_last, 4);
        data1[i].fb_sales_vs = numConvert(data1[i].fb_sales - data1[i].fb_sales_last, 4);
    }

    // table2
    data2[1].rev = _.get(data5_1_3, '2.REV', 0);
    data2[3].rev = _.get(data5_1_1, '2.REV', 0);
    data2[1].mix = _.get(data5_1_3, '2.revenue', 0);
    data2[3].mix = _.get(data5_1_1, '2.revenue', 0);
    data2[1].ac = _.get(data5_1_3, '2.AC', 0);
    data2[3].ac = _.get(data5_1_1, '2.AC', 0);
    data2[1].cost = _.get(data5_1_3, '2.cost_percent', 0);
    data2[3].cost = _.get(data5_1_1, '2.cost_percent', 0);
    data2[1].covers = _.get(data5_1_3, '2.covers', 0);
    data2[3].covers = _.get(data5_1_1, '2.covers', 0);

    data2[1].brev = _.get(data5_1_3, '2.m_REV', 0);
    data2[3].brev = _.get(data5_1_1, '2.m_REV', 0);
    data2[1].bmix = _.get(data5_1_3, '2.m_revenue', 0);
    data2[3].bmix = _.get(data5_1_1, '2.m_revenue', 0);
    data2[1].bac = _.get(data5_1_3, '2.m_AC', 0);
    data2[3].bac = _.get(data5_1_1, '2.m_AC', 0);
    data2[1].bcost = _.get(data5_1_3, '2.m_cost_percent', 0);
    data2[3].bcost = _.get(data5_1_1, '2.m_cost_percent', 0);
    data2[1].bcovers = _.get(data5_1_3, '2.m_covers', 0);
    data2[3].bcovers = _.get(data5_1_1, '2.m_covers', 0);

    data2[1].last_rev = _.get(last5_1_3, '2.m_REV', 0);
    data2[3].last_rev = _.get(last5_1_1, '2.m_REV', 0);
    data2[1].last_mix = _.get(last5_1_3, '2.m_revenue', 0);
    data2[3].last_mix = _.get(last5_1_1, '2.m_revenue', 0);
    data2[1].last_ac = _.get(last5_1_3, '2.m_AC', 0);
    data2[3].last_ac = _.get(last5_1_1, '2.m_AC', 0);
    data2[1].last_cost = _.get(last5_1_3, '2.m_cost_percent', 0);
    data2[3].last_cost = _.get(last5_1_1, '2.m_cost_percent', 0);
    data2[1].last_covers = _.get(last5_1_3, '2.m_covers', 0);
    data2[3].last_covers = _.get(last5_1_1, '2.m_covers', 0);

    for (let i = 0; i < data2.length; i++) {
        data2[i].vs = (data2[i].rev - data2[i].brev).toFixed(4);
        data2[i].bvs = (data2[i].mix - data2[i].bmix).toFixed(4);
        data2[i].bac_vs = (data2[i].ac - data2[i].bac).toFixed(4);
        data2[i].bcost_vs = (data2[i].cost - data2[i].bcost).toFixed(4);
        data2[i].bcovers_vs = (data2[i].covers - data2[i].bcovers).toFixed(4);
        data2[i].last_vs = (data2[i].rev - data2[i].last_rev).toFixed(4);
        data2[i].last_mix_vs = (data2[i].mix - data2[i].last_mix).toFixed(4);
        data2[i].last_ac_vs = (data2[i].ac - data2[i].last_ac).toFixed(4);
        data2[i].last_cost_vs = (data2[i].cost - data2[i].last_cost).toFixed(4);
        data2[i].last_covers_vs = (data2[i].covers - data2[i].last_covers).toFixed(4);
    }


    // table3
    data3[1].rev = _.get(data5_1_3, '0.REV', 0);
    data3[3].rev = _.get(data5_1_1, '0.REV', 0);
    data3[1].mix = _.get(data5_1_3, '0.revenue', 0);
    data3[3].mix = _.get(data5_1_1, '0.revenue', 0);
    data3[1].ac = _.get(data5_1_3, '0.AC', 0);
    data3[3].ac = _.get(data5_1_1, '0.AC', 0);
    data3[1].cost = _.get(data5_1_3, '0.cost_percent', 0);
    data3[3].cost = _.get(data5_1_1, '0.cost_percent', 0);
    data3[1].covers = _.get(data5_1_3, '0.covers', 0);
    data3[3].covers = _.get(data5_1_1, '0.covers', 0);

    data3[1].brev = _.get(data5_1_3, '0.m_REV', 0);
    data3[3].brev = _.get(data5_1_1, '0.m_REV', 0);
    data3[1].bmix = _.get(data5_1_3, '0.m_revenue', 0);
    data3[3].bmix = _.get(data5_1_1, '0.m_revenue', 0);
    data3[1].bac = _.get(data5_1_3, '0.m_AC', 0);
    data3[3].bac = _.get(data5_1_1, '0.m_AC', 0);
    data3[1].bcost = _.get(data5_1_3, '0.m_cost_percent', 0);
    data3[3].bcost = _.get(data5_1_1, '0.m_cost_percent', 0);
    data3[1].bcovers = _.get(data5_1_3, '0.m_covers', 0);
    data3[3].bcovers = _.get(data5_1_1, '0.m_covers', 0);

    data3[1].last_rev = _.get(last5_1_3, '0.m_REV', 0);
    data3[3].last_rev = _.get(last5_1_1, '0.m_REV', 0);
    data3[1].last_mix = _.get(last5_1_3, '0.m_revenue', 0);
    data3[3].last_mix = _.get(last5_1_1, '0.m_revenue', 0);
    data3[1].last_ac = _.get(last5_1_3, '0.m_AC', 0);
    data3[3].last_ac = _.get(last5_1_1, '0.m_AC', 0);
    data3[1].last_cost = _.get(last5_1_3, '0.m_cost_percent', 0);
    data3[3].last_cost = _.get(last5_1_1, '0.m_cost_percent', 0);
    data3[1].last_covers = _.get(last5_1_3, '0.m_covers', 0);
    data3[3].last_covers = _.get(last5_1_1, '0.m_covers', 0);

    for (let i = 0; i < data3.length; i++) {
        data3[i].vs = (data3[i].rev - data3[i].brev).toFixed(4);
        data3[i].bvs = (data3[i].mix - data3[i].bmix).toFixed(4);
        data3[i].bac_vs = (data3[i].ac - data3[i].bac).toFixed(4);
        data3[i].bcost_vs = (data3[i].cost - data3[i].bcost).toFixed(4);
        data3[i].bcovers_vs = (data3[i].covers - data3[i].bcovers).toFixed(4);
        data3[i].last_vs = (data3[i].rev - data3[i].last_rev).toFixed(4);
        data3[i].last_mix_vs = (data3[i].mix - data3[i].last_mix).toFixed(4);
        data3[i].last_ac_vs = (data3[i].ac - data3[i].last_ac).toFixed(4);
        data3[i].last_cost_vs = (data3[i].cost - data3[i].last_cost).toFixed(4);
        data3[i].last_covers_vs = (data3[i].covers - data3[i].last_covers).toFixed(4);
    }


    // table4
    data4[1].rev = _.get(data5_1_3, '1.REV', 0);
    data4[3].rev = _.get(data5_1_1, '1.REV', 0);
    data4[1].mix = _.get(data5_1_3, '1.revenue', 0);
    data4[3].mix = _.get(data5_1_1, '1.revenue', 0);
    data4[1].ac = _.get(data5_1_3, '1.AC', 0);
    data4[3].ac = _.get(data5_1_1, '1.AC', 0);
    data4[1].cost = _.get(data5_1_3, '1.cost_percent', 0);
    data4[3].cost = _.get(data5_1_1, '1.cost_percent', 0);
    data4[1].covers = _.get(data5_1_3, '1.covers', 0);
    data4[3].covers = _.get(data5_1_1, '1.covers', 0);

    data4[1].brev = _.get(data5_1_3, '1.m_REV', 0);
    data4[3].brev = _.get(data5_1_1, '1.m_REV', 0);
    data4[1].bmix = _.get(data5_1_3, '1.m_revenue', 0);
    data4[3].bmix = _.get(data5_1_1, '1.m_revenue', 0);
    data4[1].bac = _.get(data5_1_3, '1.m_AC', 0);
    data4[3].bac = _.get(data5_1_1, '1.m_AC', 0);
    data4[1].bcost = _.get(data5_1_3, '1.m_cost_percent', 0);
    data4[3].bcost = _.get(data5_1_1, '1.m_cost_percent', 0);
    data4[1].bcovers = _.get(data5_1_3, '1.m_covers', 0);
    data4[3].bcovers = _.get(data5_1_1, '1.m_covers', 0);

    data4[1].last_rev = _.get(last5_1_3, '1.m_REV', 0);
    data4[3].last_rev = _.get(last5_1_1, '1.m_REV', 0);
    data4[1].last_mix = _.get(last5_1_3, '1.m_revenue', 0);
    data4[3].last_mix = _.get(last5_1_1, '1.m_revenue', 0);
    data4[1].last_ac = _.get(last5_1_3, '1.m_AC', 0);
    data4[3].last_ac = _.get(last5_1_1, '1.m_AC', 0);
    data4[1].last_cost = _.get(last5_1_3, '1.m_cost_percent', 0);
    data4[3].last_cost = _.get(last5_1_1, '1.m_cost_percent', 0);
    data4[1].last_covers = _.get(last5_1_3, '1.m_covers', 0);
    data4[3].last_covers = _.get(last5_1_1, '1.m_covers', 0);

    for (let i = 0; i < data4.length; i++) {
        data4[i].vs = (data4[i].rev - data4[i].brev).toFixed(4);
        data4[i].bvs = (data4[i].mix - data4[i].bmix).toFixed(4);
        data4[i].bac_vs = (data4[i].ac - data4[i].bac).toFixed(4);
        data4[i].bcost_vs = (data4[i].cost - data4[i].bcost).toFixed(4);
        data4[i].bcovers_vs = (data4[i].covers - data4[i].bcovers).toFixed(4);
        data4[i].last_vs = (data4[i].rev - data4[i].last_rev).toFixed(4);
        data4[i].last_mix_vs = (data4[i].mix - data4[i].last_mix).toFixed(4);
        data4[i].last_ac_vs = (data4[i].ac - data4[i].last_ac).toFixed(4);
        data4[i].last_cost_vs = (data4[i].cost - data4[i].last_cost).toFixed(4);
        data4[i].last_covers_vs = (data4[i].covers - data4[i].last_covers).toFixed(4);
    }


    // table5
    data5[1].rev = _.get(data5_1_3, '3.REV', 0);
    data5[3].rev = _.get(data5_1_1, '3.REV', 0);
    data5[1].mix = _.get(data5_1_3, '3.revenue', 0);
    data5[3].mix = _.get(data5_1_1, '3.revenue', 0);
    data5[1].ac = _.get(data5_1_3, '3.AC', 0);
    data5[3].ac = _.get(data5_1_1, '3.AC', 0);
    data5[1].cost = _.get(data5_1_3, '3.cost_percent', 0);
    data5[3].cost = _.get(data5_1_1, '3.cost_percent', 0);
    data5[1].covers = _.get(data5_1_3, '3.covers', 0);
    data5[3].covers = _.get(data5_1_1, '3.covers', 0);

    data5[1].brev = _.get(data5_1_3, '3.m_REV', 0);
    data5[3].brev = _.get(data5_1_1, '3.m_REV', 0);
    data5[1].bmix = _.get(data5_1_3, '3.m_revenue', 0);
    data5[3].bmix = _.get(data5_1_1, '3.m_revenue', 0);
    data5[1].bac = _.get(data5_1_3, '3.m_AC', 0);
    data5[3].bac = _.get(data5_1_1, '3.m_AC', 0);
    data5[1].bcost = _.get(data5_1_3, '3.m_cost_percent', 0);
    data5[3].bcost = _.get(data5_1_1, '3.m_cost_percent', 0);
    data5[1].bcovers = _.get(data5_1_3, '3.m_covers', 0);
    data5[3].bcovers = _.get(data5_1_1, '3.m_covers', 0);

    data5[1].last_rev = _.get(last5_1_3, '3.m_REV', 0);
    data5[3].last_rev = _.get(last5_1_1, '3.m_REV', 0);
    data5[1].last_mix = _.get(last5_1_3, '3.m_revenue', 0);
    data5[3].last_mix = _.get(last5_1_1, '3.m_revenue', 0);
    data5[1].last_ac = _.get(last5_1_3, '3.m_AC', 0);
    data5[3].last_ac = _.get(last5_1_1, '3.m_AC', 0);
    data5[1].last_cost = _.get(last5_1_3, '3.m_cost_percent', 0);
    data5[3].last_cost = _.get(last5_1_1, '3.m_cost_percent', 0);
    data5[1].last_covers = _.get(last5_1_3, '3.m_covers', 0);
    data5[3].last_covers = _.get(last5_1_1, '3.m_covers', 0);

    for (let i = 0; i < data5.length; i++) {
        data5[i].vs = (data5[i].rev - data5[i].brev).toFixed(4);
        data5[i].bvs = (data5[i].mix - data5[i].bmix).toFixed(4);
        data5[i].bac_vs = (data5[i].ac - data5[i].bac).toFixed(4);
        data5[i].bcost_vs = (data5[i].cost - data5[i].bcost).toFixed(4);
        data5[i].bcovers_vs = (data5[i].covers - data5[i].bcovers).toFixed(4);
        data5[i].last_vs = (data5[i].rev - data5[i].last_rev).toFixed(4);
        data5[i].last_mix_vs = (data5[i].mix - data5[i].last_mix).toFixed(4);
        data5[i].last_ac_vs = (data5[i].ac - data5[i].last_ac).toFixed(4);
        data5[i].last_cost_vs = (data5[i].cost - data5[i].last_cost).toFixed(4);
        data5[i].last_covers_vs = (data5[i].covers - data5[i].last_covers).toFixed(4);
    }

    // table6
    data6[1].rev = _.get(data5_1_3, '4.REV', 0);
    data6[3].rev = _.get(data5_1_1, '4.REV', 0);
    data6[1].mix = _.get(data5_1_3, '4.revenue', 0);
    data6[3].mix = _.get(data5_1_1, '4.revenue', 0);
    data6[1].ac = _.get(data5_1_3, '4.AC', 0);
    data6[3].ac = _.get(data5_1_1, '4.AC', 0);
    data6[1].cost = _.get(data5_1_3, '4.cost_percent', 0);
    data6[3].cost = _.get(data5_1_1, '4.cost_percent', 0);
    data6[1].covers = _.get(data5_1_3, '4.covers', 0);
    data6[3].covers = _.get(data5_1_1, '4.covers', 0);

    data6[1].brev = _.get(data5_1_3, '4.m_REV', 0);
    data6[3].brev = _.get(data5_1_1, '4.m_REV', 0);
    data6[1].bmix = _.get(data5_1_3, '4.m_revenue', 0);
    data6[3].bmix = _.get(data5_1_1, '4.m_revenue', 0);
    data6[1].bac = _.get(data5_1_3, '4.m_AC', 0);
    data6[3].bac = _.get(data5_1_1, '4.m_AC', 0);
    data6[1].bcost = _.get(data5_1_3, '4.m_cost_percent', 0);
    data6[3].bcost = _.get(data5_1_1, '4.m_cost_percent', 0);
    data6[1].bcovers = _.get(data5_1_3, '4.m_covers', 0);
    data6[3].bcovers = _.get(data5_1_1, '4.m_covers', 0);

    data6[1].last_rev = _.get(last5_1_3, '4.m_REV', 0);
    data6[3].last_rev = _.get(last5_1_1, '4.m_REV', 0);
    data6[1].last_mix = _.get(last5_1_3, '4.m_revenue', 0);
    data6[3].last_mix = _.get(last5_1_1, '4.m_revenue', 0);
    data6[1].last_ac = _.get(last5_1_3, '4.m_AC', 0);
    data6[3].last_ac = _.get(last5_1_1, '4.m_AC', 0);
    data6[1].last_cost = _.get(last5_1_3, '4.m_cost_percent', 0);
    data6[3].last_cost = _.get(last5_1_1, '4.m_cost_percent', 0);
    data6[1].last_covers = _.get(last5_1_3, '4.m_covers', 0);
    data6[3].last_covers = _.get(last5_1_1, '4.m_covers', 0);

    for (let i = 0; i < data5.length; i++) {
        data6[i].vs = (data6[i].rev - data6[i].brev).toFixed(4);
        data6[i].bvs = (data6[i].mix - data6[i].bmix).toFixed(4);
        data6[i].bac_vs = (data6[i].ac - data6[i].bac).toFixed(4);
        data6[i].bcost_vs = (data6[i].cost - data6[i].bcost).toFixed(4);
        data6[i].bcovers_vs = (data6[i].covers - data6[i].bcovers).toFixed(4);
        data6[i].last_vs = (data6[i].rev - data6[i].last_rev).toFixed(4);
        data6[i].last_mix_vs = (data6[i].mix - data6[i].last_mix).toFixed(4);
        data6[i].last_ac_vs = (data6[i].ac - data6[i].last_ac).toFixed(4);
        data6[i].last_cost_vs = (data6[i].cost - data6[i].last_cost).toFixed(4);
        data6[i].last_covers_vs = (data6[i].covers - data6[i].last_covers).toFixed(4);
    }

    // table7
    data7[1].rev = _.get(data5_1_3, '5.REV', 0);
    data7[3].rev = _.get(data5_1_1, '5.REV', 0);
    data7[1].mix = _.get(data5_1_3, '5.revenue', 0);
    data7[3].mix = _.get(data5_1_1, '5.revenue', 0);
    data7[1].ac = _.get(data5_1_3, '5.AC', 0);
    data7[3].ac = _.get(data5_1_1, '5.AC', 0);
    data7[1].cost = _.get(data5_1_3, '5.cost_percent', 0);
    data7[3].cost = _.get(data5_1_1, '5.cost_percent', 0);
    data7[1].covers = _.get(data5_1_3, '5.covers', 0);
    data7[3].covers = _.get(data5_1_1, '5.covers', 0);

    data7[1].brev = _.get(data5_1_3, '5.m_REV', 0);
    data7[3].brev = _.get(data5_1_1, '5.m_REV', 0);
    data7[1].bmix = _.get(data5_1_3, '5.m_revenue', 0);
    data7[3].bmix = _.get(data5_1_1, '5.m_revenue', 0);
    data7[1].bac = _.get(data5_1_3, '5.m_AC', 0);
    data7[3].bac = _.get(data5_1_1, '5.m_AC', 0);
    data7[1].bcost = _.get(data5_1_3, '5.m_cost_percent', 0);
    data7[3].bcost = _.get(data5_1_1, '5.m_cost_percent', 0);
    data7[1].bcovers = _.get(data5_1_3, '5.m_covers', 0);
    data7[3].bcovers = _.get(data5_1_1, '5.m_covers', 0);

    data7[1].last_rev = _.get(last5_1_3, '5.m_REV', 0);
    data7[3].last_rev = _.get(last5_1_1, '5.m_REV', 0);
    data7[1].last_mix = _.get(last5_1_3, '5.m_revenue', 0);
    data7[3].last_mix = _.get(last5_1_1, '5.m_revenue', 0);
    data7[1].last_ac = _.get(last5_1_3, '5.m_AC', 0);
    data7[3].last_ac = _.get(last5_1_1, '5.m_AC', 0);
    data7[1].last_cost = _.get(last5_1_3, '5.m_cost_percent', 0);
    data7[3].last_cost = _.get(last5_1_1, '5.m_cost_percent', 0);
    data7[1].last_covers = _.get(last5_1_3, '5.m_covers', 0);
    data7[3].last_covers = _.get(last5_1_1, '5.m_covers', 0);

    for (let i = 0; i < data5.length; i++) {
        data7[i].vs = (data7[i].rev - data7[i].brev).toFixed(4);
        data7[i].bvs = (data7[i].mix - data7[i].bmix).toFixed(4);
        data7[i].bac_vs = (data7[i].ac - data7[i].bac).toFixed(4);
        data7[i].bcost_vs = (data7[i].cost - data7[i].bcost).toFixed(4);
        data7[i].bcovers_vs = (data7[i].covers - data7[i].bcovers).toFixed(4);
        data7[i].last_vs = (data7[i].rev - data7[i].last_rev).toFixed(4);
        data7[i].last_mix_vs = (data7[i].mix - data7[i].last_mix).toFixed(4);
        data7[i].last_ac_vs = (data7[i].ac - data7[i].last_ac).toFixed(4);
        data7[i].last_cost_vs = (data7[i].cost - data7[i].last_cost).toFixed(4);
        data7[i].last_covers_vs = (data7[i].covers - data7[i].last_covers).toFixed(4);
    }

    // table8
    const listName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    for (let i = 0; i < listName.length; i++) {
        const name = listName[i].toLowerCase();
        data[0][name] = _.get(list2_2, `0.${listName[i]}`, 0);
        data[1][name] = _.get(list2_1, `0.${listName[i]}`, 0);
    }
    data[0].actual = _.get(max, 'ytdActual', 0);
    data[0].budget = sum(listName.map(name => data[0][name.toLowerCase()]));
    data[0].forecast = sum(listName.map(name => data[1][name.toLowerCase()]));
    return {
        data,
        data1,
        data2,
        data3,
        data4,
        data5,
        data6,
        data7,
    }
}


// WEBPACK FOOTER //
// ./src/components/table/5.0/5-10/compute.js